export default __webpack_public_path__ + "static/media/pin_3d.8a819d0e.png";